import { get2 } from "@/shared/axios";
import { CmsUsersResponse } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";

const useMerchantUsersQuery = (customBranch?: number) => {
  return useQuery<CmsUsersResponse[]>({
    queryKey: ["merchants", customBranch],
    queryFn: () =>
      get2(
        `/internal/secure/pos/v1/cms/account/franchise/merchant/${customBranch}`
      ),
    enabled: customBranch !== undefined,
    select: (data) => Object.values(data),
  });
};

export default useMerchantUsersQuery;
